import { ValidationFailureDisplayModel } from "@/api/model-index";
import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'admin-check-config',
    templateUrl: './admin-check-config.component.html',
    styleUrls: ['./admin-check-config.component.scss']
})
export class AdminCheckConfigComponent {
    public errors: ValidationFailureDisplayModel[];

    constructor(protected route: ActivatedRoute) {
        this.errors = this.route.snapshot.data.checkConfig.errors;
    }
}